<app-page-template
  (clearQueryString)="onClearQueryString()"
  [showParent]="showParent"
  [class.d-none]="isShowDetail || isShowDeviceNumbers"
  [config]="pageConfig"
  (onAdd)="onCreate('', false)"
  (sortObject)="getSortItems($event)"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
>
  <!--------------------------------------------------------------- Table Content ---------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-px-4 !tw-py-2">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- deviceId -->
        <td class="tw-py-2">
          <td-value copyToClipboard [value]="item?.deviceId"></td-value>
        </td>

        <!-- organizationName -->
        <td class="tw-py-2">
          <td-value copyToClipboard [value]="item?.organizationName"></td-value>
        </td>

        <!-- webhookUrl -->
        <td class="tw-py-2">
          <td-value copyToClipboard [value]="item?.webhookUrl"></td-value>
        </td>

        <!-- phonebookIdList -->
        <td>
          <app-expand-item
            *ngIf="item?.phonebookIdList?.length > 1"
            [isCustom]="true"
            [placement]="'left'"
          >
            <ul class="custom dir-rtl tw-mb-0">
              <li *ngFor="let item of item?.phonebookIdList" class="tw-mb-1">
                {{ item }}
              </li>
            </ul>
          </app-expand-item>

          <td-value
            *ngIf="item?.phonebookIdList?.length < 2"
            copyToClipboard
            [value]="item?.phonebookIdList[0]"
          >
          </td-value>
        </td>

        <!-- status -->
        <td>
          <span [otpStatus]="item?.status" copyToClipboard>{{
            item?.status | enumToText : OtpStatusEnumValues
          }}</span>
        </td>

        <!-- created -->
        <td>
          <td-value type="dateTime" [value]="item?.created"></td-value>
        </td>
        <!------------------------------- operations -------------------------------->
        <td class="sticky-td">
          <!-- dot menu -->
          <div
            app-menu-btn
            [matMenuTriggerFor]="menu"
            [isShowDotsMenu]="true"
          ></div>

          <mat-menu #menu="matMenu" xPosition="before">
            <div
              *ngIf="userSession.organizationId() == 1"
              mat-menu-item
              color="gray"
              class="tw-flex-center text-gray border-bottom"
              (click)="onShowChangeStatus(item?.id, item.status)"
            >
              <i
                class="mdi mdi-arrow-collapse mdi-20px tw-ml-[10px] ltr:tw-mr-[10px]"
              ></i>
              <span class="mat-menu-title tw-font-medium">{{
                "common.changeStatusTo" | translate
              }}</span>
            </div>

            <!-- edit button -->
            <div
              app-menu-btn
              *ngIf="item?.organizationId == userSession.organizationId()"
              icon="edit"
              (click)="onUpdate(item.id)"
            ></div>

            <!-- detail button -->
            <div
              app-menu-btn
              *ngIf="item?.organizationId != userSession.organizationId()"
              icon="details"
              color="gray"
              (click)="onGetDetailById(item.id, item?.organizationId)"
            ></div>

            <!-- device numbers button -->
            <div
              app-menu-btn
              icon="mdi-cellphone mdi-18px"
              color="blue"
              title="common.deviceNumbers"
              (click)="onDeviceNumbers(item.id)"
            ></div>

            <!-- delete button -->
            <div
              app-menu-btn
              icon="delete"
              (click)="onDelete(item.id, item.deviceId)"
            ></div>
          </mat-menu>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!-- form -->
<ng-container *ngIf="pageConfig?.isVisibleForm">
  <app-customer-club-devices-form
    [formPageConfig]="formPageConfig"
    [organizationId]="organizationId"
    [userId]="userId"
    (closeFormPage)="getFormResponse($event)"
  >
  </app-customer-club-devices-form>
</ng-container>

<!-- detail -->
<ng-container *ngIf="isShowDetail">
  <app-customer-club-devices-details
    [model]="detailModel"
    [organizationId]="organizationId"
    (closePage)="
      isShowDetail = false; showParent = true; getParentQueryString()
    "
  >
  </app-customer-club-devices-details>
</ng-container>

<!-- device numbers -->
<ng-container *ngIf="isShowDeviceNumbers">
  <app-customer-club-device-numbers
    [customerClubDeviceId]="customerClubDeviceId"
    (closePage)="isShowDeviceNumbers = false"
  >
  </app-customer-club-device-numbers>
</ng-container>

<!-- Audit -->
<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    [methodName]="auditApiMethodName"
    [sortReferenceId]="false"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>
<!--------------------------------------------------------------- help ---------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
